




















import {Vue, Component} from 'vue-property-decorator'
import Footers from '@/components/Footers.vue'

@Component({
  name: 'ClaimNotFound',
  components: {Footers}
})
export default class ClaimNotFound extends Vue {
  private onClickClose(){
    window.close();
  }
}
